//
// Module for the Interest Edit view
//
rs.module("content/participant/member/interest/edit",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl, reportMethodIsBenefitSetup) {

            var form = $.js(jsSelectors.form);

            var planNameSelect = form.js(jsSelectors.planSelect);
            var contributionsSelect = form.js(jsSelectors.contributionSelect);

            // Get Select Helper for contributionsSelect since we're updating its options and properties
            var contributioneSelectHelper = selectHelper.getHelper(contributionsSelect);

            enableDisableFields();

            planNameSelect.change(planSelected);

            // On plan change, handle population of associated contributions
            function planSelected() {

                var noSelection = planNameSelect.val() == "";

                if (noSelection || reportMethodIsBenefitSetup) {
                    contributioneSelectHelper.clearOptions();
                }
                else {

                    var selectedPlanKey = planNameSelect.val();

                    contributioneSelectHelper.loadOptionsFrom(backendUrl, { planKey: selectedPlanKey }, { withBlank: true });
                }

                enableDisableFields();
            }

            // enable or disable contributions select based on whether or not a plan is selected and the report method
            function enableDisableFields() {

                var noSelection = planNameSelect.val() == "";

                contributioneSelectHelper.setDisabled(noSelection || reportMethodIsBenefitSetup);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);